import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SelectCompany } from '@app/features/companies/select-company/select-company';
import { SelectUser } from '@app/features/users/select-user/select-user';
import { realmRoles, UserRole } from '@app/features/users/user.model';
import { IAuthenticatedUserService } from '@app/shared/auth/authenticated-user-service/authenticated-user-service';
import { AUTHENTICATED_USER_SERVICE } from '@app/shared/auth/authenticated-user-service/authenticated-user-service.token';
import { SearchForm } from '@app/shared/forms/search-form/search-form';
import { ContractsTable } from '../contracts-table/contracts-table';
import { MultiSelectContractStatus } from '../multi-select-contract-status/multi-select-contract-status';

const validatorRoles: UserRole[] = [
  'responsable-exploitation',
  'responsable-rh',
  'directeur-agence',
  'directeur-production',
  'directeur-rh',
];
@Component({
  selector: 'app-search-contract-form',
  imports: [
    SearchForm,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    SelectCompany,
    MultiSelectContractStatus,
    SelectUser,
    MatSlideToggleModule,
  ],
  templateUrl: './search-contract-form.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./search-contract-form.scss'],
})
export class SearchContractForm implements OnInit {
  tableController = input.required<ContractsTable>();

  readonly realmRoles = realmRoles;
  private readonly authenticatedUserService = inject(
    AUTHENTICATED_USER_SERVICE,
  ) as IAuthenticatedUserService;

  ngOnInit(): void {
    this.initDefaultFilters();
  }

  initDefaultFilters() {
    const userRoles = this.authenticatedUserService.realmRoles;
    if (userRoles.includes('administration-du-personnel')) {
      this.tableController().searchForm.patchValue({
        statuses: ['SIGNING'],
      });
      return;
    }
    if (userRoles.includes('assistant-de-production')) {
      this.tableController().searchForm.patchValue({
        statuses: ['DRAFT'],
        createdByUserId: this.authenticatedUserService.userId,
      });
      return;
    }
    if (userRoles.some((role) => validatorRoles.includes(role))) {
      this.tableController().searchForm.patchValue({
        pendingValidationRequestRequestedToUserId: this.authenticatedUserService.userId,
      });
      return;
    }
  }
}
